import { API_ENDPOINT } from "@/utils/misc";
import axios from "axios";

export const get = () => {
  return axios.get(`${API_ENDPOINT()}/horeca-locations`);
};
